// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + chunkId + "." + {"144": "ce4d6875","984": "847e791d",}[chunkId] + ".js"
}